module.exports = __webpack_public_path__ + "img/partner13.1e8d1d69.png";